import { Locale } from '@infiltre/shared';
import { de } from './messages.de';
import { en, type Messages } from './messages.en';
import { es } from './messages.es';
import { fr } from './messages.fr';
import { pt } from './messages.pt';

export const messages = {
  [Locale.EN]: en,
  [Locale.FR]: fr,
  [Locale.ES]: es,
  [Locale.DE]: de,
  [Locale.PT]: pt,
} as const satisfies Record<Locale, Messages>;

export type MessageKey = keyof Messages;
